import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Menu } from 'antd';
import {
	iconCertificate,
	iconGift,
	iconHome,
	iconService,
	iconTeleWhite
} from 'assets/icons';
import classNames from 'classnames';
import { AppRoutes } from 'constants/appRoutes';
import { KEY_MENU, LINK_DEV } from 'constants/index';
import { isNullOrEmpty } from 'functions';
import useConvertMenu from 'hooks/useConvertMenu';
import useDevice from 'hooks/useDevice';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

export default function DrawerMenuLeft({ showDrawer, onCloseDrawer }) {
	const navigate = useNavigate();
	const { isMobile } = useDevice();
	const {
		checkRender,
		menuFilter,
		dataFuncSupport,
		setMenuActive,
		menuActive,
		isShowContract,
		isShowGift,
		isAdmin,
	} = useConvertMenu();

	let location = useLocation();

	const onSelectItem = () => {
	  setMenuActive('');
    onCloseDrawer();
	}

	const renderMenuApi = () => {
		return menuFilter.map((item, index) => {
			const isChildren = item?.children?.length > 0;

			if (!isChildren) {
				return (
					<Item
						onSelectItem={onSelectItem}
						key={item?.menuId || index}
						icon={isMobile ? <div className='w-23px' /> : <span />}
						value={''}
						link={item.menuPath}
						text={item.menuName}
						isActiveProp={item.menuPath === location.pathname}
					/>
				);
			} else {
				const menuChild = (
					<MenuStyled
						selectedKeys={menuActive}
						onClick={(e) => {
							setMenuActive(e.key);
						}}
						device={isMobile ? 'mobile' : 'pc'}
					>
						{item.menuId === 'retrieve-contact' &&
						!isNullOrEmpty(dataFuncSupport)
							? item?.children?.map((itemChild, i) => {
									const isRenderChild = checkRender(dataFuncSupport, itemChild);
									if (isRenderChild) {
										return (
											<Menu.Item key={itemChild.menuId || i}>
												<div
													className='font-roboto-medium'
													onClick={() => {
														onCloseDrawer && onCloseDrawer();
														navigate(itemChild.menuPath);
													}}
												>
													{itemChild.menuName}
												</div>
											</Menu.Item>
										);
									} else return null;
							  })
							: item?.children?.map((itemChild, i) => {
									return (
										<Menu.Item key={itemChild.menuId || i}>
											<div
												className='font-roboto-medium'
												onClick={() => {
													onCloseDrawer && onCloseDrawer();
													navigate(itemChild.menuPath);
												}}
											>
												{itemChild.menuName}
											</div>
										</Menu.Item>
									);
							  })}
					</MenuStyled>
				);

				const hasActive = item?.children?.find(
					(item) => item?.menuPath === location.pathname
				);

				return (
					<div
						className={classNames({
							'rounded-8px py-10px px-20px cursor-pointer transition-all duration-300 mr-5px hover:bg-white hover:bg-opacity-20': true,
							'bg-transparent': !hasActive,
							'bg-white bg-opacity-20 border-opacity-30 border-1 border-solid border':
								hasActive,
						})}
					>
						<div className='flex justify-between text-white'>
							<div className='text-16px text-white leading-19px title-head-menu hover:opacity-80'>
								<p className='line-clamp-1 text-16px font-averta-bold'>
									{item.menuName.toLowerCase()}
								</p>
							</div>
							<p className='transform rotate-90 text-12px ml-8px'>►</p>
						</div>
						<div className='mt-3px'>{menuChild}</div>
					</div>
				);
			}
		});
	};

	const listMenu = (
		<>
			<Item
				onSelectItem={onSelectItem}
				value={KEY_MENU.home}
				link={AppRoutes.home}
				text='Trang chủ'
				icon={<img src={iconHome} />}
			/>
						{isShowGift && (
				<Item
					onSelectItem={onSelectItem}
					value={KEY_MENU.gift}
					link={AppRoutes.gift}
					text='Quà tặng'
					icon={<img src={iconGift} />}
				/>
			)}
			{renderMenuApi()}
			{!isAdmin && (
				<>
					<Item
						onSelectItem={onSelectItem}
						value={KEY_MENU.service}
						link={AppRoutes.productsAndServices}
						text='Dịch vụ'
						icon={<img src={iconService} />}
					/>
					<Item
						onSelectItem={onSelectItem}
						value={KEY_MENU.contact}
						link={AppRoutes.contactUs}
						text='Liên hệ'
						icon={<img src={iconTeleWhite} />}
					/>
				</>
			)}
		</>
	);

	return (
		<DrawerStyled
			placement={'left'}
			closable={false}
			onClose={onCloseDrawer}
			visible={showDrawer}
			key={'left'}
			width={350}
			destroyOnClose={true}
		>
			<div style={{ width: '90%' }}>{listMenu}</div>
			<CloseIcon
				className='w-30px absolute top-33px right-10px text-white'
				onClick={onCloseDrawer}
			/>
		</DrawerStyled>
	);
}

const Item = ({ text, icon, link, value, isActiveProp, onSelectItem }) => {
	const navigate = useNavigate()
	const onChange = () => {
		onSelectItem && onSelectItem();
		if(link !== '/pages/loyalty-store'){
			window.location.href = `${LINK_DEV}${link}`
		}
	};

	return (
		<div
			onClick={onChange}
			className={classNames({
				'rounded-8px py-10px px-20px cursor-pointer transition-all duration-300 mr-5px hover:bg-white hover:bg-opacity-20': true,
				'bg-white bg-opacity-20 border-opacity-30 border-1 border-solid border': true
			})}
		>
			<div className='text-16px text-white leading-19px flex items-center hover:opacity-80'>
				{icon && <div className='mr-12px'>{icon}</div>}
				<div className='title-head-menu'>
					<p className='text-16px line-clamp-1 font-averta-bold'>{text}</p>
				</div>
			</div>
		</div>
	);
};

const DrawerStyled = styled(Drawer)`
	.ant-drawer-body {
		background: linear-gradient(180deg, #008bd2 0%, #004f9f 100%);
	}
`;

const MenuStyled = styled(Menu)`
	background: ${(props) =>
		props.device == 'mobile' ? 'transparent' : 'white'};
	border-right: 0;
	.ant-menu-item > * {
		color: white;
	}
	.ant-menu-item-selected {
		background-color: #89b9cf !important;
	}
`;
